export enum SettingsRoutes {
  Index = "/settings",
  AccountDetails = "/settings/account/details",
  AccountPreferences = "/settings/account/preferences",
  CompanyIndex = "/settings/company",
  CompanyOverview = "/settings/company/overview",
  EmailDomains = "/settings/account/domains",
  CompanyLocation = "/settings/company/location",
  CompanySocials = "/settings/company/socials",
  CompanyBanners = "/settings/company/banners",
  CompanyCustomTerms = "/settings/company/custom-terms",
  CompanyMembers = "/settings/company/members",
}
